import { Link } from 'react-router-dom';
import { PageShell, PageHero } from '@/components/site/PageShell';
import { Seo } from '@/components/seo/Seo';
import { SITE } from '@/content/site';
import { EnvelopeSimple, Clock, ShieldWarning, Scales } from '@phosphor-icons/react';

const topics = [
  { icon: EnvelopeSimple, title: 'General & support', text: 'Account help, bugs, feedback and partnership enquiries.', subject: 'Support request' },
  { icon: ShieldWarning, title: 'Report a player', text: 'Include the username, game or room, time and a screenshot.', subject: 'Player report' },
  { icon: Scales, title: 'Privacy & legal', text: 'Data access or deletion requests, copyright notices and grievances.', subject: 'Privacy request' },
];

const mailto = (subject) => `mailto:${SITE.email}?subject=${encodeURIComponent(`[DashLink] ${subject}`)}`;

export default function ContactPage() {
  return (
    <PageShell testId="contact-page">
      <Seo title="Contact Us" description={`Contact DashLink Gaming for support, player reports, privacy requests and feedback. Email ${SITE.email}.`} />
      <PageHero eyebrow="Contact" title="Talk to a real person.">
        <p>DashLink Gaming is run by a small team. The fastest way to reach us is email — we read every message.</p>
      </PageHero>
      <section className="max-w-6xl mx-auto px-6 py-20 grid gap-12 lg:grid-cols-[1.2fr_1fr]">
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-[#71717A] mb-3">Email</p>
          <a href={mailto('Hello')} className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-[#0047FF] hover:underline break-all" data-testid="contact-email-link">
            {SITE.email}
          </a>
          <div className="mt-8 flex items-start gap-3 text-[#3F3F46]">
            <Clock size={22} className="text-[#0047FF] shrink-0 mt-0.5" />
            <p data-testid="contact-response-time">We aim to reply within 2–3 business days. Privacy requests are answered within 30 days, as required by law.</p>
          </div>
          <p className="mt-6 text-sm text-[#71717A] leading-relaxed">
            Before writing, you might find a quick answer in our <Link to="/faq" className="text-[#0047FF] underline">FAQ</Link>. For safety issues, please also read the <Link to="/community-guidelines" className="text-[#0047FF] underline">Community Guidelines</Link>.
          </p>
          <p className="mt-6 text-sm text-[#71717A]">Operator: {SITE.operator} · Online service available worldwide</p>
        </div>
        <div className="space-y-4">
          {topics.map(({ icon: Icon, title, text, subject }) => (
            <a key={title} href={mailto(subject)} className="flex gap-4 p-6 border border-[#E4E4E7] hover:border-[#0047FF] transition-colors group"
              data-testid={`contact-topic-${subject.toLowerCase().replace(/\s+/g, '-')}`}>
              <Icon size={26} className="text-[#0047FF] shrink-0" />
              <span>
                <span className="block font-heading font-bold text-[#09090B] group-hover:text-[#0047FF] transition-colors">{title}</span>
                <span className="block text-sm text-[#71717A] mt-1">{text}</span>
              </span>
            </a>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
